export function ScrollIntoViewLink({
  children,
  target,
  className,
}: {
  children: React.ReactNode;
  target: string;
  className?: string;
}) {
  const scrollIntoview = (target: string) => {
    const element = document.querySelector(target);
    element &&
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      });
  };

  return (
    <a className={className} onClick={() => scrollIntoview(target)}>
      {children}
    </a>
  );
}
